module.exports = __webpack_public_path__ + "static/media/talks.be31a59d.png";